module.exports = __webpack_public_path__ + "media/images/import-4a61d2f3.png";